import styled from 'styled-components';

import { HEADER_HEIGHT } from 'view/layout/header-dumb/styled';
import * as grid from 'view/styles/grid';
import * as zIndex from 'view/styles/z-index';
import { SidebarPusher } from 'view/common/pushing-customize-sidebar';
import { Flipper } from 'view/common/flip-toolkit';
import { token } from '@atlaskit/tokens';

export const BANNER_HEIGHT = grid.multiple(44);
const CONTAINER_MIN_HEIGHT = '100vh';
export const SidebarPusherRoot = styled(SidebarPusher)`
    display: flex;
    flex-direction: column;
`;

export const Container = styled.div`
    position: relative;
    /* Important for the body to not expand past the viewport. */
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
    min-height: ${CONTAINER_MIN_HEIGHT};
`;

export const PaperContainer = styled.div`
    position: relative;
    display: flex;
    flex: 1 1 auto;
    overflow: hidden;
`;

interface BannerProps {
    imageSrc?: string;
}

export const Banner = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: ${BANNER_HEIGHT.px};
    z-index: ${zIndex.banner};
    background-color: ${(props) => token('color.background.brand.bold', props.theme.color)};
    background-image: ${(props: BannerProps) => (!!props.imageSrc ? `url(${props.imageSrc})` : 'none')};
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
`;

export const EmptyHeader = styled.div`
    height: ${HEADER_HEIGHT}px;
    width: 100%;
`;

export const FlipperWithFlexbox = styled(Flipper)`
    display: flex;
    flex-direction: column;
`;
